export { BulletPoints } from "./BulletPoints";
export type { BulletPointsProps } from "./BulletPoints";
